
import React, { useState } from 'react';

import { IsModemAccess, amountFormatUse, getToken, utc_local } from '../../../helpers/Helper';
import { POST_INVOICE_LIST, POST_PDF_INVOICE } from '../../../helpers/url_helper';
import ReactDOM from 'react-dom/client';
import useMounted from '../../../hooks/useMounted';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import $ from 'jquery';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/dataTables.dataTables.css";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const UserRoles = (props) => {
    const navigate = useNavigate();
    const [filter_option, setFilterOption] = useState({ status: '', startDate: '', endDate: '' });

    useMounted(() => {
        if (!IsModemAccess('invoice', 'view')) {
            toast.error('Does not permission this module');
            navigate("/admin/dashboard");
        }
        get_invoice_list()
    },[navigate])

    const get_invoice_list = () => {
        const tableElement = $('#dataTableExample');
        if (tableElement.length > 0) {
            tableElement.DataTable({
                destroy: true,
                "bProcessing": true,
                "bServerSide": true,
                'searching': true,
                'stateSave': true,
                "scrollX": false,
                "sServerMethod": "POST",
                "order": [[0, 'desc']],
                columnDefs: [
                    { orderable: false, targets: [7] },
                    { "targets": '', "visible": false }
                ],
                "ajax": function (data, callback, settings) {
                    data.sSearch = data.search.value;
                    data.iDisplayLength = data.length;
                    data.iDisplayStart = data.start;
                    data.sSortDir_0 = (data.order.length > 0) ? data.order[0].dir : '';
                    data.iSortCol_0 = (data.order.length > 0) ? data.order[0].column : '';

                    data.status = filter_option.status;
                    data.startDate = (filter_option.startDate) ? new Date(filter_option.startDate).getTime() : '';
                    data.endDate = (filter_option.endDate) ? new Date(filter_option.endDate).getTime() : '';

                    $.ajax({
                        "url": POST_INVOICE_LIST,
                        "type": "POST",
                        "data": data,
                        "headers": { 'Authorization': getToken() },
                        "error": function (xhr, status, error) {
                            if (xhr.status === 401) {
                                navigate("/logout");
                            }
                        },
                        "success": callback
                    });
                },
                "columns": [
                    { "data": "invoiceId" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {utc_local(data.createdAt)}
                            </>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                <span className='text-primary pointer' onClick={() => { window.open('/admin/users/view/' + data.companyId, '_blank'); }}>{data.companyName} </span>
                            </>)
                        }
                    },
                    { "data": "email" },
                    { "data": "name" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {amountFormatUse(data.totalAmount)}
                            </>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {data.paymentStatus === 'Unpaid' && <span className='text-danger'>{data.paymentStatus}</span>}
                                {data.paymentStatus === 'Paid' && <span className='text-success'>{data.paymentStatus}</span>}
                                {data.paymentStatus === 'Canceled' && <span className='text-danger'>{data.paymentStatus}</span>}
                            </>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                <a href={`${POST_PDF_INVOICE}${data.invoiceId}`} target="_blank" rel="noreferrer"  className={`btn btn-sm text-info`}><i className="bx bxs-file-pdf"></i></a>
                            </>)
                        }
                    },

                ]
            });
        }
    }

    // input text change handler
    const handleInputChangeFilter = (event) => {
        setFilterOption(inputs => ({ ...filter_option, [event.target.name]: event.target.value }));
    }

    const clear = () => {
        filter_option.status = ''
        filter_option.startDate = ''
        filter_option.endDate = ''
        setFilterOption({ ...filter_option });
        get_invoice_list();
    }
    return (
        <>
            <div className='row'>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div className='row mb-3'>
                                <div className='col-sm-6'>
                                    <h5 className='mt-1'>Invoices </h5>
                                </div>
                                <div className='col-sm-6 text-right'>
                                </div>
                            </div>
                            <hr />
                            <div className='row mt-4 mb-3'>
                                <div className='col-sm-3 mb-3'>
                                    <DatePicker name='startDate' className='form-control'
                                        selected={filter_option.startDate} onChange={(date) => { handleInputChangeFilter({ target: { name: 'startDate', value: date } }) }}
                                        placeholderText="Start Date"
                                        dateFormat="dd/MM/yyyy"
                                        onKeyDown={(e) => e.preventDefault()}
                                    />
                                </div>
                                <div className='col-sm-3 mb-3'>
                                    <DatePicker name='endDate' className='form-control'
                                        selected={filter_option.endDate} onChange={(date) => { handleInputChangeFilter({ target: { name: 'endDate', value: date } }) }}
                                        placeholderText="End Date"
                                        dateFormat="dd/MM/yyyy"
                                        onKeyDown={(e) => e.preventDefault()}
                                    />
                                </div>
                                <div className='col-sm-3 mb-3'>
                                    <select name='status' className='form-control' value={filter_option.status} onChange={handleInputChangeFilter}>
                                        <option value="">All</option>
                                        <option value="Unpaid">Unpaid</option>
                                        <option value="Paid">Paid</option>
                                        <option value="Canceled">Canceled</option>
                                    </select>
                                </div>
                                <div className='col-sm-3 mb-3'>
                                    <button type='button' onClick={get_invoice_list} className='btn btn-primary me-3'>Apply</button>
                                    <button type='button' onClick={clear} className='btn btn-danger'>Clear</button>
                                </div>
                            </div>
                            <div className='table-responsive text-nowrap'>
                                <table id="dataTableExample" className="table table-striped">
                                    <thead>
                                        <tr>
                                            <td>Invoice</td>
                                            <td>Invoice Date</td>
                                            <td>Company Name</td>
                                            <td>Email</td>
                                            <td>Plan Name</td>
                                            <td>Total</td>
                                            <td>Status</td>
                                            <td>Action</td>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default UserRoles;